import type { LabeledValuePayload } from '@Application/Users/UserStatuses/Actions/userStatusesFetched';

export type SubjectFieldNaturesFetchedPayload = LabeledValuePayload[];

export type SubjectFieldNaturesFetchedAction = {
	type: 'SUBJECT_FIELD_NATURES_FETCHED';
	payload: SubjectFieldNaturesFetchedPayload;
};

export default (payload: SubjectFieldNaturesFetchedPayload): SubjectFieldNaturesFetchedAction => ({
	type: 'SUBJECT_FIELD_NATURES_FETCHED',
	payload,
});
